(function ($) {

    $.fn.camcomAccess = function () {

        const init = function () {

                const triggers = $('.ugp_register_user, .ugp_login_user, .ugp_remind_user');

                /*                var passwordCheck = $('#registration_password_one').passwordRequirements({
                                    numCharacters: 6,
                                    style: 'dark'
                                });*/

                triggers.on('click', function (event) {

                    event.preventDefault();

                    $(this).blur();

                    var trigger = $(this),
                        triggerAction = trigger.data('action');

                    trigger.html('Working...');

                    switch (triggerAction) {

                        case 'register':

                            var formElem = trigger.parents('form'),
                                firstNameValid = 0,
                                lastNameValid = 0,
                                emailValid = 0,
                                passwordValid = 1;

                            formElem.find('.form__error').addClass('is-hidden');

                            var emailCheck = ugpValidate('email', $('#registration_email')),
                                firstNameCheck = ugpValidate('hasNumber', $('#registration_first_name')),
                                lastNameCheck = ugpValidate('hasNumber', $('#registration_last_name'));

                            if (!emailCheck.result) {

                                $(emailCheck.elem[0]).next().html('Invalid Email.').removeClass('is-hidden')

                            } else {

                                emailValid = 1;

                            }

                            /*if (passwordCheck.hasClass('check-pass')) {

                                passwordValid = 1;

                            } else {

                                $('#registration_password_one').next().html('Password too weak.').removeClass('is-hidden');

                            }*/

                            if (firstNameCheck.result) {

                                $(firstNameCheck.elem[0]).next().html('Invalid Name.').removeClass('is-hidden');

                            } else {

                                firstNameValid = 1;

                            }

                            if (lastNameCheck.result) {

                                $(lastNameCheck.elem[0]).next().html('Invalid Name.').removeClass('is-hidden');

                            } else {

                                lastNameValid = 1;

                            }

                            formElem.find('input').each(function () {

                                var inputElem = $(this);

                                if (!inputElem.val()) {

                                    inputElem.next().html('Value cannot be empty.').removeClass('is-hidden');

                                    firstNameValid = lastNameValid = emailValid = passwordValid = 0;

                                }

                            });

                            if (firstNameValid && lastNameValid && emailValid && passwordValid) {

                                registerUser();

                            }

                            break;

                        case 'login':


                            loginUser($('#login_username').val(), $('#login_password').val(), $('#login_remember').val());
                            break;

                        case 'reminder':

                            forgottenPassword(trigger);
                            break;

                    }

                });

            },
            registerUser = function () {

                $('#registration_ajax_response').empty();

                $.ajax({
                    url: ajax_variables.ajax_url,
                    method: 'POST',
                    dataType: 'JSON',
                    data: {
                        'action': 'ugp_trigger_register_user',
                        'first_name': $('#registration_first_name').val(),
                        'last_name': $('#registration_last_name').val(),
                        'email': $('#registration_email').val(),
                        'password': $('#registration_password_one').val(),
                        'redirect': $('#ugp_login_redirect').val()
                    },
                    success: function (data) {

                        if (data.errors) {

                            $.each(data.errors, function (index, error_message) {

                                $('#registration_ajax_response').append('<p class="form__error">' + error_message + '</p>')

                            });

                        } else if (data.success) {

                            loginUser($('#registration_email').val(), $('#registration_password_one').val(), true);

                        }

                    }

                });


            },
            loginUser = function (username, password, remember) {

                var accessRedirect = $('#modal_login input[name="access_redirect"]').val();

                var currentUrl = window.location.href.substr(0, window.location.href.indexOf('#')).replace(/\/$/, '');

                if (!currentUrl) {

                    currentUrl = window.location.href.replace(/\/$/, '');

                }

                $('#login_ajax_response').empty();

                $.ajax({
                    url: ajax_variables.ajax_url,
                    method: 'POST',
                    dataType: 'JSON',
                    data: {
                        'action': 'ugp_trigger_login_user',
                        'username': username,
                        'password': password,
                        'remember': remember
                    },
                    success: function (data) {

                        if (data.errors) {

                            $.each(data.errors, function (index, error_message) {

                                $('#login_ajax_response').append('<p class="form__error">' + error_message + '</p>');

                            });

                        } else if (data.success) {

                            if (window.location.href == accessRedirect.substr(0, accessRedirect.indexOf('#'))) {

                                location.reload(true);

                            } else {

                                window.location.replace(accessRedirect);

                            }

                        }

                    }

                });

            },
            forgottenPassword = function (trigger) {

                console.log('forgottenPassword', trigger.parents('.form').find('input[name="email_reset"]').val());

                $.ajax({
                    url: ajax_variables.ajax_url,
                    method: 'POST',
                    //dataType: 'JSON',
                    data: {
                        'action': 'ugp_trigger_password_reset_email',
                        'email': trigger.parents('.form').find('input[name="email_reset"]').val()
                    },
                    success: function (data) {

                        $('.ugp_remind_user').html('Reset Password');

                        $('#login_ajax_response').html('<p class="form__notice breathe breathe--top-midi">If the email address is registered, a reset password link will be in your inbox shortly.</p>');

                    }
                })

            };


        init();

        return this;

    }

}(jQuery));